<template>
  <div>
    <div v-if="showContainer" class="callout-container" :class="currentClasses">
      <slot />
    </div>

    <div v-if="showEdition" class="callout-edition">
      <div :class="{ 'callout-edition-body': hasEditionBgWhite }">
        <slot name="edition" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomCallout',
  meta: {
    description: 'Componente común para ser usado como contenedor.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    /**
     * Permite mostrar contenido para editar. */
    showEdition: {
      type: Boolean,
      default: () => false,
    },
    /**
     * Indica el color del borde izquierdo. Enumeración en import { Colors } from "@/components/common" */
    borderColor: {
      type: String,
      default: '',
    },
    /** Muestra el contenido */
    showContainer: {
      type: Boolean,
      default: true,
    },
    hasEditionBgWhite: {
      type: Boolean,
      default: () => true,
    },
    customClass: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    currentClasses() {
      return 'borderColor ' + this.borderColor + ' ' + this.customClass;
    },
  },
};
</script>

<style scoped>
.callout-container {
  padding: 15px;
  background-color: #f7f7f7;
  border-left: 3px solid #e8e8e8;
  border-radius: 5px;
  color: #727272;
}
.callout-edition {
  margin: 0 1px 1px 1px;
  background-color: #f7f7f7;
  border-radius: 5px 5px 5px 5px;
  padding: 5px;
}
.callout-edition > div > div {
  margin: 10px 10px 0 10px;
  margin-top: 0;
  background-color: white;
  padding-bottom: 10px;
}
.callout-edition-body {
  background-color: #f7f7f7;
  border-radius: 4px;
  padding: 5px 0 10px 0;
}
.callout-container.green {
  border-left: 3px solid #a4e5b2;
}
.callout-container.dark-green {
  border-left: 4px solid #2db782;
}
.callout-container.brown {
  border-left: 3px solid #d5b89a;
}
.callout-container.yellow {
  border-left: 3px solid #f8ea80;
}
.callout-container.pink {
  border-left: 3px solid #fcc9c8;
}
.callout-container.violet {
  border-left: 3px solid #ddb3d7;
}
.callout-container.pink-error {
  border-left: 3px solid #ffa5ad;
}
.callout-container.orange {
  border-left: 3px solid #ff7058;
}
.callout-container.danger {
  border-left: 3px solid #c5525c;
}
.callout-container.celadon {
  border-left: 3px solid #a3e5b3;
}
.callout-container.chardonnay {
  border-left: 3px solid #ffc18d;
}
.callout-container.green-light {
  border-left: 3px solid #a4e5b2;
}
.callout-container.secondary-38 {
  border-left: 3px solid #f8b184;
}
.callout-container.secondary-24 {
  border-left: 3px solid #fae76f;
}
</style>
